import {PlayClass} from "../generic/PlayClass";

// TODO: Could improve this by adding sub classes
export class PianoSectionClass extends PlayClass {
  public isAdvised(): boolean {
    return true;
  }
}
